(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[934],{

/***/ 1194:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/menu",
      function () {
        return __webpack_require__(1452);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2339:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ MenuWrapper; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _Title__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8198);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_icons_ri__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9352);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);



// import MenuWrapperItem from "./MenuWrapperItem";



function MenuWrapper() {
    var liste = function liste(param) {
        var id = param.id, btnname = param.btnname;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
            className: "py-2 px-6 rounded-3xl ".concat(isSeciliBtn === true ? "bg-secondary text-white" : "text-black"),
            onClick: function() {
                return setSeciliBtn(true);
            },
            children: btnname
        }, id);
    };
    var mwiliste = // menuwrapper itemlerı için mwiliste funtionu oluşturuyoruz. Bu funtction döngü ile çekilecek
    function mwiliste(param) {
        var id = param.id, gorsel = param.gorsel, baslik = param.baslik, fiyat = param.fiyat, yazi = param.yazi;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "bg-secondary rounded-3xl",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "w-full bg-[#f1f2f3] h-[180px] grid place-content-center rounded-bl-[46px] rounded-tl-2xl rounded-tr-2xl",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
                        href: "/product",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "relative w-36 h-36 z-50 hover:scale-110 transition-all",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                src: gorsel,
                                alt: "",
                                layout: "fill"
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "text-white p-[25px]",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                            className: "font-semibold text-3xl font-dancing grid place-content-center",
                            children: baslik
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: "text-[15px] mt-3",
                            children: yazi
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex justify-between p-[10px] items-center mt-2",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    children: fiyat
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    className: "bg-primary w-10 h-10 rounded-full grid place-content-center",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_ri__WEBPACK_IMPORTED_MODULE_5__/* .RiShoppingCart2Fill */ .tac, {})
                                })
                            ]
                        })
                    ]
                })
            ]
        }, id);
    };
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isSeciliBtn = ref[0], setSeciliBtn = ref[1];
    var data = [
        {
            id: 1,
            btnname: "All"
        },
        {
            id: 2,
            btnname: "Burger"
        },
        {
            id: 3,
            btnname: "Pizza"
        },
        {
            id: 4,
            btnname: "Pasta"
        },
        {
            id: 5,
            btnname: "Fries"
        }, 
    ];
    // menuwrapper itemlerı için dizi oluşturuyoruz
    var mwidata = [
        {
            id: 1,
            gorsel: "/images/sebzelipizza.png",
            baslik: "Delicious Pizza",
            fiyat: "$20",
            yazi: "Veniam debitis quaerat officiis quasi cupiditate quo, quisquam velit, magnam voluptatem repellendus sed eaque"
        },
        {
            id: 2,
            gorsel: "/images/hamburger4.png",
            baslik: "Delicious Burger",
            fiyat: "$15",
            yazi: "Veniam debitis quaerat officiis quasi cupiditate quo, quisquam velit, magnam voluptatem repellendus sed eaque"
        },
        {
            id: 3,
            gorsel: "/images/sebzelipizza.png",
            baslik: "Delicious Pizza",
            fiyat: "$17",
            yazi: "Veniam debitis quaerat officiis quasi cupiditate quo, quisquam velit, magnam voluptatem repellendus sed eaque"
        },
        {
            id: 4,
            gorsel: "/images/kasarlimakarna.png",
            baslik: "Delicious Pasta",
            fiyat: "$18",
            yazi: "Veniam debitis quaerat officiis quasi cupiditate quo, quisquam velit, magnam voluptatem repellendus sed eaque"
        },
        {
            id: 5,
            gorsel: "/images/kizartma.png",
            baslik: "French Fries",
            fiyat: "$10",
            yazi: "Veniam debitis quaerat officiis quasi cupiditate quo, quisquam velit, magnam voluptatem repellendus sed eaque"
        },
        {
            id: 6,
            gorsel: "/images/yesilpizza.png",
            baslik: "Delicious Pizza",
            fiyat: "$15",
            yazi: "Veniam debitis quaerat officiis quasi cupiditate quo, quisquam velit, magnam voluptatem repellendus sed eaque"
        },
        {
            id: 7,
            gorsel: "/images/hamburger2.png",
            baslik: "Tasty Burger",
            fiyat: "$12",
            yazi: "Veniam debitis quaerat officiis quasi cupiditate quo, quisquam velit, magnam voluptatem repellendus sed eaque"
        },
        {
            id: 8,
            gorsel: "/images/hamburger3.png",
            baslik: "Tasty Burger",
            fiyat: "$14",
            yazi: "Veniam debitis quaerat officiis quasi cupiditate quo, quisquam velit, magnam voluptatem repellendus sed eaque"
        },
        {
            id: 9,
            gorsel: "/images/kasarlimakarna.png",
            baslik: "Delicious Pasta",
            fiyat: "$10",
            yazi: "Veniam debitis quaerat officiis quasi cupiditate quo, quisquam velit, magnam voluptatem repellendus sed eaque"
        }, 
    ];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "container mx-auto flex flex-col items-center mb-16 my-16",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Title__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                baslik: "Our Menu",
                addClass: "font-dancing text-5xl"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex justify-center my-8 gap-5",
                children: data.map(function(id, btnname) {
                    return liste(id = id, btnname = btnname);
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "mt-8 grid md:grid-cols-3 sm:grid-cols-3 grid-cols-1 gap-4 ",
                children: mwidata.map(function(id, gorsel, baslik, fiyat, yazi) {
                    return mwiliste(id = id, gorsel = gorsel, baslik = baslik, fiyat = fiyat, yazi = yazi);
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                    className: "bg-primary text-white rounded-[45px] mt-[45px] flex justify-center px-[55px] py-[10px]",
                    children: "View more"
                })
            })
        ]
    });
};


/***/ }),

/***/ 1452:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ index; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _components_Product_MenuWrapper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2339);


function index() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Product_MenuWrapper__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {})
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [937,774,888,179], function() { return __webpack_exec__(1194); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);